"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.timeUnits = new localized_strings_1.default({
    en: {
        Day: {
            AbbreviatedDisplay: 'd',
            FullDisplay: 'day'
        },
        Hour: {
            AbbreviatedDisplay: 'h',
            FullDisplay: 'hour'
        },
        Minute: {
            AbbreviatedDisplay: 'm',
            FullDisplay: 'minute'
        },
        Second: {
            AbbreviatedDisplay: 's',
            FullDisplay: 'second'
        },
        Year: {
            AbbreviatedDisplay: 'y',
            FullDisplay: 'year'
        }
    }
}, {
    logsEnabled: false
});
